var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2L7 2C6.44771 2 6 1.55228 6 1C6 0.447715 6.44771 0 7 0H15C15.5523 0 16 0.447716 16 1C16 1.55229 15.5523 2 15 2L12 2V3L15 3C15.3148 3 15.6111 3.14819 15.8 3.4L18.5 7H20V6C20 5.44772 20.4477 5 21 5C21.5523 5 22 5.44772 22 6V14C22 14.5523 21.5523 15 21 15C20.4477 15 20 14.5523 20 14V13.5H19V15C19 16.1046 18.1046 17 17 17H7.60555C7.01328 17 6.43425 16.8247 5.94145 16.4962L3.4453 14.8321C3.1671 14.6466 3 14.3344 3 14V11H2L2 14C2 14.5523 1.55228 15 1 15C0.447715 15 0 14.5523 0 14V6C0 5.44772 0.447715 5 1 5C1.55228 5 2 5.44772 2 6L2 9H3V7C3 6.44772 3.44772 6 4 6H4.26393C4.6427 6 4.98897 5.786 5.15836 5.44721L6.10557 3.55279C6.27496 3.214 6.62123 3 7 3L10 3V2ZM5 13.4648L7.05085 14.8321C7.21512 14.9416 7.40813 15 7.60555 15H17V13.5C17 12.3954 17.8954 11.5 19 11.5H20V9H18C17.6852 9 17.3889 8.85181 17.2 8.6L14.5 5H7.61803L6.94721 6.34164C6.55161 7.13286 5.83443 7.6972 5 7.9084V13.4648Z",
    fill: "#8B8C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 10.8284 11.8284 11.5 11 11.5C10.1716 11.5 9.5 10.8284 9.5 10C9.5 9.17157 10.1716 8.5 11 8.5C11.8284 8.5 12.5 9.17157 12.5 10Z",
    fill: "#8B8C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/Engine.4a27deab.svg";
export { ForwardRef as ReactComponent };